import { cn } from '@/utils/utils_client';
import * as RADIX__context_menu from '@radix-ui/react-context-menu';
import * as React from 'react';

export const UI_PRIMITIVE__context_menu_separator = React.forwardRef<
  React.ElementRef<typeof RADIX__context_menu.Separator>,
  React.ComponentPropsWithoutRef<typeof RADIX__context_menu.Separator>
>(({ className, ...props }, ref) => <RADIX__context_menu.Separator ref={ref} className={cn('-mx-1  h-px bg-border cursor-default', className)} {...props} />);
UI_PRIMITIVE__context_menu_separator.displayName = RADIX__context_menu.Separator.displayName;
